import { useLayoutEffect/* , useState  */} from 'react';
import { store }                     from 'index'
import { SET_SIZE_STATE } from 'actions/uiActions';

const useSize = () => {
   // const [size, setSize] = useState([0,0]); 
   

    useLayoutEffect(() => {
      function updateSize() {
      //  setSize([window.innerWidth, window.innerHeight]);
       store.dispatch(SET_SIZE_STATE({ size: [window.innerWidth, window.innerHeight] }))
      }
      window.addEventListener('resize', updateSize);
  
      updateSize();
      return () => { 
        window.removeEventListener('resize', updateSize); 
      }
    }, []);

  //  return size;
  
}

export default useSize;

